// extracted by mini-css-extract-plugin
module.exports = {"CommentsButton":"hm_a bag_tu bag_iv bag_uh bag_i bag_j bag_q bag_sr bag_en bag_pm bag_pn bag_cx","CommentsButton__icon":"hm_b bag_pi"};